"use client";

import type { ReactNode } from "react";
import { cn } from "../../lib";
import {
	OctagonBadge,
	type OctagonBadgeHoverVariant,
} from "../octagon-badge/octagon-badge";
import { OCTAGON_BUTTON_DEFAULT_SIZE_PX } from "../octagon-badge/octagon-geometry";
import "./octagon-button-surfaces.css";

export type OctagonButtonHoverVariant = OctagonBadgeHoverVariant;

export interface OctagonButtonChromeProps {
	size?: number;
	interactive?: boolean;
	active?: boolean;
	disabled?: boolean;
	hoverVariant?: OctagonButtonHoverVariant;
	className?: string;
	children?: ReactNode;
}

/**
 * Interactive octagon button chrome — delegates to {@link OctagonBadge} with button surface.
 */
export function OctagonButtonChrome({
	size = OCTAGON_BUTTON_DEFAULT_SIZE_PX,
	interactive = true,
	active = false,
	disabled = false,
	hoverVariant = "brightness",
	className,
	children,
}: OctagonButtonChromeProps) {
	return (
		<OctagonBadge
			size={size}
			surface="button"
			layoutFootprint="visual"
			interactive={interactive}
			active={active}
			disabled={disabled}
			hoverVariant={hoverVariant}
			shadowHostClassName={cn(
				"sq-octagon-button-shadow-host size-full min-h-0 min-w-0",
				className,
			)}
		>
			{children}
		</OctagonBadge>
	);
}
